<template>
  <div>
    <Header></Header>
    <div class="articleCon">
      <div class="top">
        <div class="title open">ARTICLE</div>
        <div class="search">
          <div class="searchBox">
            <div class="left"></div>
            <div class="right">
              <input type="text" @change="search" v-model="inputValue"/>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <transition-group enter-active-class="slideLeftReturn" @after-enter="afterEnter" :css='transDel'>
          <div class="box hvr-bounce-in" @click="showModal(item.id)"  v-for="item in items" :key="item.id">
            <div class="cover">
              <img :src="item.image" alt="">
            </div>
            <div class="title">{{item.title}}</div>
            <div class="author">{{item.author}}</div>
          </div>
        </transition-group>
        <div class="pagination">
          <el-pagination
            :background="true"
            :current-page="query.page"
            :page-size=12
            layout=" prev, pager, next, jumper"
            :total="query.count"
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            >
          </el-pagination>
        </div>
      </div>
      <div class="modal" ref="modal">
        <a-modal
          v-model="visible"
          :getContainer="() => $refs.modal"
          width="40vh"
          :zIndex=3
          centered
          :footer="null"
          :closable="false"
          :destroyOnClose="true"
        >
          <p v-html="item"></p>
        </a-modal>
        <div class="return" v-if="visible" @click="closeModal"></div>
        <!-- <div class="last" v-if="visible"></div>
        <div class="next" v-if="visible"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
      inputValue:'',
      visible: false,
      transDel: true,
      items:[],
      item:{},
      query: {
        page:1,
        limit: 12,
        sort: { _id: -1 },
        where:{
          status:10
        }
      },
    };
  },
  created(){
    this.getData()
  },
  methods: {
    async getData() {
      const article = await this.$axios.get("article", {
        params: {
          query: this.query,
        },
      });
      this.query.count = article.data.total
      this.items = article.data.data;
      console.log(this.items)
    },
    async getArt(id) {
      const article = await this.$axios.get("article/"+id, {
      });
      this.item = article.data.body;
    },
    async search() {
      this.query = {
        limit: 12,
        sort:{"_id":-1},
        where:{"title" :{"$regex":this.inputValue }}
      }
      this.getData()
    },
    showModal(id) {
      this.visible = true;
      this.getArt(id)
    },
    closeModal(){
      this.visible = false;
      this.item = {}
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getData()
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getData()
    },
    afterEnter(){
      this.transDel = false
    },
    onChange(){
      this.getData()
    }
  }
};
</script>
<style scoped>
.articleCon {
  width: 100%;
  height: 100vh;
  padding-top: 8vh;
  background-color: #000;
}
@media screen and (max-height:670px){
  .articleCon{
    padding-top: 55px;
  }
}
hr {
  width: 100%;
  border: none;
  height: 1px;
  background: #888;
  margin: 0;
}
::-webkit-scrollbar {
  display: none;
}
.articleCon .top {
  width: 100%;
  min-width: 999px;
  height: 15vh;
  min-height: 100px;
  border-top: #888 1px solid;
  border-bottom: #888 1px solid;
  background-color: #000;
  position: fixed;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  padding: 0 30px;
  box-sizing: border-box;
  z-index: 2;
}
.articleCon .top .title {
  grid-area: 1 / 1 / 2 / 2;
  font-size: 5.5vw;
  line-height: calc(15vh - 2px);
  font-weight: bold;
  color: #fff;
}
@media screen and (max-width:999px){
  .articleCon .top .title {
    font-size: 55px;
    line-height: 100px;
  }
}
@media screen and (max-height:670px){
  .articleCon .top .title{
    line-height: 100px;
  }
}
.open {
    width: 21.5vw;
    overflow: hidden;
    display: inline-flex;
    animation: open 1s linear;
}
@media screen and (max-width:999px){
  .open {
    width: 215px;
  }
}
@keyframes open {
    from { width: 0 }
}
.articleCon .top .search {
  grid-area: 1 / 2 / 2 / 3;
  min-height: 100px;
}
.articleCon .top .search .searchBox {
  width: 35vh;
  height: 4.5vh;
  min-height: 30px;
  float: right;
  transform: translateY(calc((15vh - 4.5vh) / 2));
  display: grid;
  grid-template-columns: 1fr 7fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.articleCon .top .search .searchBox .left {
  height: inherit;
  min-height: 30px;
  grid-area: 1 / 1 / 2 / 2;
  border: #999 1px solid;
  background: transparent url("../../assets/search.png") center no-repeat;
  background-size: 70%;
}
.articleCon .top .search .searchBox .right {
  height: inherit;
  min-height: 30px;
  grid-area: 1 / 2 / 2 / 3;
  border: #888 1px solid;
  border-left: none;
}
.articleCon .top .search .searchBox .right input {
  width: calc(100% / 8 * 7 - 1px);
  height: calc(100% - 2px);
  min-height: 30px;
  background: #000;
  color: #aaa;
  font-size: 16px;
  padding: 5px;
  box-sizing: border-box;
  border: none;
  position: absolute;
}
input:focus {
  outline: none;
}
.articleCon .content {
  width: 100%;
  height: 90vh;
  position: fixed;
  padding: 0 15px;
  box-sizing: border-box;
  padding-top: 18vh;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  overflow: scroll;
}
.articleCon .content span{
  display: contents;
}
.articleCon .content .box {
  height: fit-content;
  margin: 15px;
  color: #fff;
  width: calc((100% - 120px) / 4);
  cursor: pointer;
  animation-duration: 1s;
  transition: all 0.4s ease-in-out;
}
@media screen and (max-width:1333px){
  .articleCon .content .box {
    width: calc((100% - 120px) / 3);
  }
}
@media screen and (max-width:999px){
  .articleCon .content .box {
    width: calc((100% - 120px) / 2);
  }
}
@media screen and (max-width:666px){
  .articleCon .content .box {
    width: calc((100% - 120px) / 1);
  }
}
.articleCon .content .box:hover{
  transform: scale(1.05);
}
.articleCon .content .box:hover .cover {
  box-shadow: 0 0 15px #fff;
}
.articleCon .content .box .cover {
  width: 100%;
  height: 33vh;
  background-color: #222;
}
.articleCon .content .box .cover img{
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.articleCon .content .box .title {
  font-size: 0.9vw;
  margin: 5px 0;
}
.articleCon .content .box .author {
  font-size: 0.8vw;
}
.articleCon .content .pagination{
  width: inherit;
  text-align: end;
}
.articleCon .content .pagination /deep/ .el-pagination .el-select .el-input .el-input__inner {
    padding-right: 25px;
    background: #000;
    color: #fff;
    border-radius: 0;
    border: 1px solid #999;
}
.articleCon .content .pagination /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #999;
    color: #fff;
}
.articleCon .content .pagination /deep/ .el-pagination.is-background .el-pager li,
.articleCon .content .pagination /deep/ .el-pagination.is-background .btn-next,
.articleCon .content .pagination /deep/ .el-pagination.is-background .btn-prev{
    border-radius: 0;
    background: #000;
    color: #fff;
    border: 1px solid #999;
}
.articleCon .content .pagination /deep/ .el-pagination__editor.el-input .el-input__inner,
.articleCon .content .pagination /deep/ .el-pagination__jump{
    background: #000;
    color: #fff;
}
.articleCon .content .pagination /deep/ .el-pagination__jump input{
  border-radius: 0;
}
/* .articleCon .updown {
  width: 30px;
  height: 77vh;
  background: transparent url("../../assets/updown.png") center no-repeat;
  background-size: 15px 68vh;
  position: fixed;
  top: 23vh;
  right: 0;
} */
/* .articleCon .updown .up{

}
.articleCon .updown .down{

} */
.modal /deep/ .ant-modal {
  height: 75vh;
  overflow: hidden;
  padding: 0;
  border-radius: 0;
}
.modal /deep/ .ant-modal-content {
  height: 100%;
  overflow: hidden;
  background-color: #000;
  border: #fff 1px solid;
  color: #fff;
}
.modal /deep/ .ant-modal-body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal /deep/ .ant-modal-body img,
.modal /deep/ .ant-modal-body svg{
  width: 100% !important;
  max-width: 100%;
  height: auto !important;
  object-fit: contain;
}
.modal /deep/ .ant-modal-body h1{
  color: #fff;
  font-size: 1.2vw;
}
.modal /deep/ .ant-modal-body p,
.modal /deep/ .ant-modal-body span,
.modal /deep/ .ant-modal-body strong,
.modal /deep/ .ant-modal-body section{
  font-size: 0.75vw !important;
  color: #fff !important;
  /* background-color: #000 !important; */
  background-image: none !important;
  margin: 0;
  filter: drop-shadow(0 0 0.4px #000);
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar {
  width: 1.5vh;
  background: #000;
  border-left: 1px solid #fff;
  display: block;
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar-thumb {
  background-color: #fff;
}
.modal .return {
  color: #fff;
  width: 5vh;
  height: 5vh;
  border-radius: 2.5vh;
  border: #fff 1px solid;
  position: absolute;
  z-index: 5;
  left: calc(50% - 2.5vh);
  bottom: 5%;
  background: transparent url("../../assets/return.png") center no-repeat;
  background-size: 60%;
}
.modal .last {
  color: #fff;
  width: 5vh;
  height: 5vh;
  border-radius: 2.5vh;
  border: #fff 1px solid;
  position: absolute;
  z-index: 5;
  left: calc(50% - 28vh);
  bottom: calc(50% - 2.5vh);
  background: transparent url("../../assets/last.png") center no-repeat;
  background-size: 30%;
}
.modal .next {
  color: #fff;
  width: 5vh;
  height: 5vh;
  border-radius: 2.5vh;
  border: #fff 1px solid;
  position: absolute;
  z-index: 5;
  right: calc(50% - 28vh);
  bottom: calc(50% - 2.5vh);
  background: transparent url("../../assets/next.png") center no-repeat;
  background-size: 30%;
}
</style>


// WEBPACK FOOTER //
// src/view/pc/Article.vue